import { FC, useEffect, useState } from 'react';
import { Modal } from '@praktio/common-ui';

import FormTextArea from '../common/FormTextArea';

interface IModalProps {
  notice?: string;
  show: boolean;
  onSave: (data: string) => void;
  onHide: () => void;
}

const AddUpdateNoticeModal: FC<IModalProps> = ({ notice, show, onSave, onHide }) => {
  const [data, setData] = useState<string>(notice || '');
  useEffect(() => {
    setData(notice || '');
  }, [notice, show]);

  const onChange = (value: any) => {
    setData(value);
  };

  return (
    <Modal
      title="System Notice"
      onSave={() => onSave(data)}
      onHide={onHide}
      show={show}
      saveText={notice ? 'APPLY' : 'ADD'}
    >
      {show && (
        <form>
          <FormTextArea name="" onChange={onChange} value={data} />
        </form>
      )}
    </Modal>
  );
};

export default AddUpdateNoticeModal;
